import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-form';
import styles from './password.scss';
import {
    Input,
    PasswordValidation,
} from '../Form';

import { createReactFormValidator, requiredPassword, requiredEmail, EMAIL_MAX_LENGTH } from '../../utils/validation';
import { NewUserOnboardingIDs } from '../Analytics/testIDConfig';

const CreatePasswordForm = (props) => {
    const { auth, onSubmit, submitting, error, signInClicked, defaultValues: defaults, themeV3 } = props;

    const defaultValues = defaults || {
        ...auth,
    };

    return (
        <div>
            <Form
                onSubmit={values => onSubmit(values)}
                defaultValues={defaultValues}
            >
                {(formApi) => {
                    const { submitForm, values } = formApi;
                    const handleFormSubmit = (event) => {
                        event.preventDefault();
                        submitForm();
                    };
                    return (
                        <form onSubmit={handleFormSubmit} className={styles.joinForm} data-testid="create-account.form">
                            <Input
                                id={`emailInput`}
                                field={`email`}
                                maxLength={EMAIL_MAX_LENGTH}
                                placeholder={!themeV3 && `Email address`}
                                validate={createReactFormValidator(requiredEmail)}
                                hiddenLabel={!themeV3}
                                label={themeV3 && 'Email'}
                                themeV3={themeV3}
                                data-testid={`${NewUserOnboardingIDs.signUpEmailInput.component}-${NewUserOnboardingIDs.signUpEmailInput.location}-${NewUserOnboardingIDs.signUpEmailInput.id}`}
                            />

                            <Input
                                id="passwordInput"
                                field="password"
                                type="password"
                                validate={createReactFormValidator(requiredPassword)}
                                placeholder={!themeV3 && `Enter password`}
                                hiddenLabel={!themeV3}
                                label={themeV3 && 'Password'}
                                themeV3={themeV3}
                                data-testid={`${NewUserOnboardingIDs.signUpPasswordInput.component}-${NewUserOnboardingIDs.signUpPasswordInput.location}-${NewUserOnboardingIDs.signUpPasswordInput.id}`}
                            />
                            <PasswordValidation
                                formApi={formApi}
                                themeV3
                            />
                            {error && error !== 'Email already registered' && (
                                <div className={styles.errorText} dangerouslySetInnerHTML={{ __html: error }} data-testid="create-account.error-text" />
                            )}
                            {error && error === 'Email already registered' && (
                                <div className={styles.errorText} data-testid="create-account.email-registered-error">
                                    {values.email} is already registered. Do you want to&nbsp;
                                    <span
                                        data-testid={`${NewUserOnboardingIDs.signInButton.component}-${NewUserOnboardingIDs.signInButton.location}-${NewUserOnboardingIDs.signInButton.id}`}
                                        className={`text-teal cursor-pointer`}
                                        onClick={() => signInClicked(values.email)}
                                    >sign in
                                    </span>
                                    ?
                                </div>
                            )}
                            <div>
                                <button
                                    data-testid={`${NewUserOnboardingIDs.signUpButton.component}-${NewUserOnboardingIDs.signUpButton.location}-${NewUserOnboardingIDs.signUpButton.id}`}
                                    type="submit"
                                    className={`btn btn-primary btn-xl btn-block fw600`}
                                    disabled={submitting}
                                >
                                    SIGN UP WITH EMAIL
                                </button>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(CreatePasswordForm);
